import {Keying2Label, Keying2Shortcode} from "../../../../api/Keying2";
import {NativeAutoComplete} from "../hardware/NativeAutoComplete";
import * as React from "react";
import {useContext, useEffect, useRef} from "react";
import {columnCount} from "./Keying2";
import {KeyingEditingContext} from "./KeyingEditingContextProvider";
import {ShortCode} from "./ShortCode";

export function CreateShortCode(props: {
    project: number;
    onShortcodes(search: string): Keying2Shortcode[];
    labels: Keying2Label[];
}) {
    const [create, setCreate] = React.useState<Keying2Shortcode | null>(null);

    const editCtx = useContext(KeyingEditingContext);
    const editCtxLastEditingRef = useRef(editCtx.editing);

    useEffect(() => {
        if(editCtxLastEditingRef.current?.id === -1) {
            setCreate(null);
        }

        editCtxLastEditingRef.current = editCtx.editing;

        const defaultValue = editCtxLastEditingRef.current?.defaultValue;

        if(editCtxLastEditingRef.current?.id === -1 && !!defaultValue) {
            setCreate(defaultValue);
        }
    }, [editCtx.editing]);

    return (
        <>
            {create && <ShortCode
                value={create}
                labels={props.labels}
            />}
            <tr>
                <td colSpan={columnCount} style={{
                    fontWeight: "600"
                }}>
                    Create Shortcode
                </td>
            </tr>
            <tr>
                <td colSpan={columnCount}>
                    <NativeAutoComplete<Keying2Shortcode>
                        placeholder="Start typing a shortcode to create"
                        onSearch={async search => props.onShortcodes(search)}
                        makeLabel={v => v.name}
                        onAssign={v => {}}
                        onCreate={v => {

                            const defaultValue = makeCreateShortcode({
                                project: props.project,
                                name: v,
                            });

                            editCtx.onEdit({
                                id: defaultValue.id,
                                defaultValue,
                            });
                        }} />
                </td>
            </tr>
        </>
    )
}

export function makeCreateShortcode(props: {
    project: number;
    name: string;
}): Keying2Shortcode {
    return {
        id: -1,
        logisticsMode: "factory-key",
        project: props.project,
        name: props.name,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        archived: false,
        openings: [],
        miscItems: [],
        products: [
            {
                id: -1,
                name: props.name,
                project: props.project,
                shortcode: -1,
                byOthers: false,
                labelsSelected: [],
                qtyMeta: [],
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                archived: false,
            } as any
        ],
    }
}